<template>
  <div id="destination-imported-work-edit">
    <destination-work-edit
      :isImportEditMode="true"
    >
    </destination-work-edit>
  </div>
</template>

<script>

import DestinationWorkEdit from "./DestinationWorkEdit";

export default {
  components: {
    DestinationWorkEdit
  }
}
</script>

<style lang="scss" scoped>
</style>
